import React from 'react';
import { RoughNotation } from 'react-rough-notation';

export const Highlighter = ({ 
    children, 
    action = 'underline', 
    color = '#ffc107', 
    strokeWidth = 2,
    animationDuration = 600,
    animate = true,
    iterations = 2
}) => {
    return (
        <RoughNotation
            type={action}
            show={animate}
            color={color}
            strokeWidth={strokeWidth}
            animationDuration={animationDuration}
            iterations={iterations}
            animationDelay={300}
            padding={[10, 2]}
            multiline={true}
        >
            {children}
        </RoughNotation>
    );
};
